var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-12652.751 2953.251 12.5 8.171"}},[_c('path',{attrs:{"d":"M-12652.001 2957.001l3.638 3.671 7.362-6.671","data-name":"path","fill":"none","stroke":"#35bd26","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5"}})])};var toString = function () {return "/Library/WebServer/Documents/iwp-vue-client/iwp-vue-client/src/assets/ticksimple.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/ticksimple.svg
// module id = H6s8
// module chunks = 3